import { Route, Routes } from 'react-router-dom';

import PublicRequestConfig from './views/PublicRequestConfig';
import LocationsConfig from './views/LocationsConfig';
import MainView from './views/MainView';

import withTitle from 'components/Routes/withTitleHoc';

const PublicRequestsView = withTitle(PublicRequestConfig);
const LocationsConfigView = withTitle(LocationsConfig);
const AllConfigsView = withTitle(MainView);

const PlanExpired = () => {
  return (
    <Routes>
      <Route
        path="/public-requests"
        element={<PublicRequestsView title="Requests" renderGoBackIcon />}
      />
      <Route
        path="/location-config"
        element={<LocationsConfigView title="Locations" renderGoBackIcon />}
      />
      <Route path="/" element={<AllConfigsView title="Configurations" />} />
    </Routes>
  );
};

export default PlanExpired;
